import React from 'react';
import { Modal } from '@shopify/polaris';

const ModalComponent = ({
    title,
    primaryAction,
    secondaryActions,
    children,
    activator,
    titleHidden,
    handleModalClose,
    open
}) => {
    return (
        <Modal
            activator={activator}
            open={open}
            titleHidden={titleHidden}
            onClose={handleModalClose}
            title={title}
            primaryAction={primaryAction}
            secondaryActions={secondaryActions}
        >
            <Modal.Section>
                {children}
            </Modal.Section>
        </Modal>
    );
}

export default ModalComponent;
